var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.3334C5.39746 18.3334 1.66663 14.6026 1.66663 10.0001C1.66663 5.39758 5.39746 1.66675 9.99996 1.66675C14.6025 1.66675 18.3333 5.39758 18.3333 10.0001C18.3333 14.6026 14.6025 18.3334 9.99996 18.3334ZM9.16663 12.5001V14.1667H10.8333V12.5001H9.16663ZM10.8333 11.1292C11.503 10.9274 12.078 10.4917 12.4534 9.90153C12.8289 9.31136 12.9799 8.60596 12.8789 7.9138C12.7779 7.22165 12.4317 6.58878 11.9033 6.13046C11.3749 5.67214 10.6994 5.41886 9.99996 5.41675C9.32567 5.4167 8.67218 5.65021 8.15062 6.07758C7.62906 6.50494 7.27163 7.09977 7.13913 7.76091L8.77413 8.08841C8.82053 7.85627 8.93189 7.64208 9.09526 7.47076C9.25864 7.29944 9.4673 7.17803 9.69698 7.12067C9.92666 7.0633 10.1679 7.07234 10.3926 7.14672C10.6174 7.22111 10.8164 7.35778 10.9665 7.54084C11.1166 7.7239 11.2116 7.94582 11.2405 8.18078C11.2694 8.41574 11.231 8.65408 11.1298 8.86807C11.0285 9.08205 10.8686 9.26288 10.6686 9.38952C10.4686 9.51616 10.2367 9.5834 9.99996 9.58341C9.77894 9.58341 9.56698 9.67121 9.4107 9.82749C9.25442 9.98377 9.16663 10.1957 9.16663 10.4167V11.6667H10.8333V11.1292Z",
    fill: "url(#paint0_linear_462_1979)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_1979",
    x1: 18.3333,
    y1: 10.078,
    x2: 1.6704,
    y2: 10.3286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE83A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF961B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.f26357ad56f66144409f66d4692981d6.svg";
export { ForwardRef as ReactComponent };